import React, { useEffect, useState } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Grid, Box, CssBaseline, useMediaQuery } from '@mui/material';
import Header from '../../header';
import SideBar from '../../sidebar';
import routeNames from '../../../routes/routeNames';
import { setHeaderTitle, setSideBarMenuItemId } from '../../../redux/reducers/headerReducer';
import { getCompanyByHash, getAllCompanies, getUserCompany, getCompanyConfigurationByTag, postCompanyConfigurationAuto } from '../../../redux/thunks/companyThunks';
import { getAuthUser } from '../../../redux/thunks/userThunks';
import { actions, actions as companyActions } from '../../../redux/reducers/companyReducer';
import { HEADER_TITLES, MENU_ITEM } from '../../../constants';

export default function Layout() {
    const location = useLocation();
    const dispatch = useDispatch();
    const { setCompanyHash, setCompany } = companyActions;
    const { headerTitle } = useSelector((state) => state.header);
    const { userDetails: { is_admin } } = useSelector((state) => state.user);
    const { company: { id: companyId },companies } = useSelector((state) => state.company);
    const [open, setOpen] = useState(true);
    const isMobile = useMediaQuery('(max-width:600px)');
    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const renderHeaderTitle = (path) => {
        const title = HEADER_TITLES[path];
        if(title){
            const menuItemId = MENU_ITEM[title];
            dispatch(setHeaderTitle(title));
            dispatch(setSideBarMenuItemId(menuItemId));
        }
    };

    const handleCompanyHash = () => {
        dispatch(setCompanyHash());
        const companyHash = localStorage.getItem('c');
        dispatch(getCompanyByHash({ companyHash }));
    };

    const handleUser = () => {
        dispatch(getAuthUser()).then((response)=> {
            if(response.payload.user.is_admin){
                dispatch(getAllCompanies()).then(()=>{
                    handleCompanyHash();
                }).catch(error => {
                    console.error('Error in Getting All Companies', error);
                });
            } else if (response.payload.user.is_staff && response.payload.user.allowed_companies !== null){
                dispatch(getAllCompanies()).then((result)=>{
                    const option = {
                        label: result.payload.companies[0].name,
                        value: result.payload.companies[0].id,
                        companyDetails: result.payload.companies[0]
                    };
                    dispatch(setCompany(option));
                }).catch(error => {
                    console.error('Error in Getting All Companies', error);
                });
            } else {
                dispatch(getUserCompany());
            }
        }).catch(error => {
            console.error('Error in Getting User Authentication', error);
        });
    };

    useEffect(()=> {
        handleUser();
    }, []);
    
    useEffect(() => {
        renderHeaderTitle(location.pathname);
    }, [location.pathname]);

    useEffect(()=>{
        if(isMobile){
            setOpen(false);
        } else{
            setOpen(true);
        }
    },[isMobile]);

    useEffect(()=>{
        if(companyId && companies.length){
            dispatch(getCompanyConfigurationByTag({ companyId: companyId })).then((response) => {

                if(response.payload?.status_code !== 200){
                    dispatch(postCompanyConfigurationAuto({
                        companyId: companyId, data: { 
                            'tag': 'useUnified',
                            'value': 'false'
                        } 
                    })).then((response) => {
                        dispatch(getCompanyConfigurationByTag({ companyId: companyId }));
                    });
                }
            });
            dispatch(actions.getIsOmaniChannel({ companyId: companyId, companies: companies }));
        }
    },[companyId]);

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            {/* Header */}
            <Header
                closeDrawer={handleDrawerClose}
                drawerOpen={open}
                headerTitle={headerTitle}
                openDrawer={handleDrawerOpen}
            />
            {/* SideBar */}
            {
                 
            }
            <SideBar
                closeDrawer={handleDrawerClose}
                drawerOpen={open}
                openDrawer={handleDrawerOpen}
                sx = {{ display: `${isMobile && !open ? 'none': 'block'}` }}
            />
            <Box component="main" sx={{
                flexGrow: 1, minWidth: 0, padding: '32px', boxSizing: 'border-box', height: '100vh'
            }}>
                <DrawerHeader />
                <Grid sx={{ marginTop: '5px' }}>
                    {/* Contents */}
                    <Outlet />
                </Grid>
            </Box>
        </Box>
    );
}

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar
}));
